import { gql, useMutation } from '@apollo/client'

export const USER_INVITATION_ACCEPT = gql`
  mutation UserInvitationAccept(
    $invitationToken: String!
    $password: String!
    $passwordConfirmation: String!
    $schoolId: ID!
  ) {
    userInvitationAccept(
      input: {
        invitationToken: $invitationToken
        password: $password
        passwordConfirmation: $passwordConfirmation
        schoolId: $schoolId
        clientMutationId: "user-invitation-accept"
      }
    ) {
      status
      token
      redirectUrl
      errors
    }
  }
`

export interface IUserInvitationAcceptResult {
  userInvitationAccept: {
    status: 'success' | 'invalid_token' | 'error'
    token: string | null
    redirectUrl: string | null
    errors: string[]
  }
}

export interface IUserInvitationAcceptInput {
  invitationToken: string
  password: string
  passwordConfirmation: string
  schoolId: string
}

export const useUserInvitationAccept = () => {
  const [acceptInvitation, { loading, error }] =
    useMutation<IUserInvitationAcceptResult>(USER_INVITATION_ACCEPT)

  const handleAcceptInvitation = async (input: IUserInvitationAcceptInput) => {
    const response = await acceptInvitation({ variables: input })
    return response.data?.userInvitationAccept
  }

  return { handleAcceptInvitation, loading, error }
}
